"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @category Guard
 * @returns `true` if the value is defined and has a value, AKA is not null
 * @example
 * ```typescript
 *   const value: string | null = localStorage.getItem("something");
 *   if(isPresent(value)) return [value];
 * ```
 */
const isPresent = ((value) => {
    return value !== undefined && value !== null;
});
exports.default = isPresent;
